import { useSelector } from 'react-redux';

const useIsAdvertiser = () => {
  const role = useSelector(state => state.auth.currentUser.role);
  return role === 'advertiser';
};

export default useIsAdvertiser;
